import React from 'react';
import { Modal, Button, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';

const EventsFilter = ({ open, handleClose, handleApply }) => {
    return (
        <div>
            <Modal isOpen={open} toggle={handleClose}>
                {/* <ModalHeader toggle={handleClose}>Filter Events</ModalHeader> */}
                <ModalBody>
                    <Form inline onSubmit={(e) => e.preventDefault()}>
                        <FormGroup className="col-12 mb-2">
                            <Label className="col-4" for="exampleSelect">
                                Departments
                            </Label>
                            <Input className="col-8" id="exampleSelect" name="select" type="text"></Input>
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => handleApply()}>
                        Apply
                    </Button>
                    <Button color="secondary" onClick={() => handleClose()}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default EventsFilter;
